import { useHistory } from 'react-router-dom';
import { hasTextSelected } from 'utils/functions/Browser';

import { EntityEnum, generateWorkspaceUri } from '@project44/entity-ui-utils';

function useDetailsRedirect() {
  const history = useHistory();
  const handleRedirect = (entity: EntityEnum, entityId: string) => {
    if (!hasTextSelected()) {
      history.push(
        generateWorkspaceUri({
          type: entity,
          id: entityId,
        }),
        {
          workspaceClearUrl: `${history.location.pathname}${history.location.search}`,
        },
      );
    }
  };

  return handleRedirect;
}

export default useDetailsRedirect;
